/**
 * Функция для генерации события в натив о показе баннера, сообщающего о наличии барьера для публикации (нет средств, не заполнены поля и тд)
 * @param label уникальный лейбл баннера, который позволит apps определить, какое сообщение о барьере для публикации сейчас отображается юзеру
 * @returns событие для нативного приложения
 */
export const generateErrorBannerShowAction = (label: string) => ({
  action: 'error-show',
  payload: { label },
});
